import { createAction } from 'redux-act';
import fetch from 'axios';
import indexEvent from './index';
import indexConflicts from 'actions/conflict/index';
import indexTasks from 'actions/task/index';


/**
 * Create the action
 */
const request = createAction('CLEAR_PERIOD_REQUEST');
const success = createAction('CLEAR_PERIOD_SUCCESS');
const error = createAction('CLEAR_PERIOD_ERROR');

function clearPeriod(data) {
    return function(dispatch, getState) {

        // Dispatch the request action
        dispatch(request);

        const token = getState().authentication.token.access_token;

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };

        return fetch.post('/api/event-clear-period', data, {
            headers: headers
        })
            .then(({ data }) => {

                // Dispatch successa action
                dispatch(success(data));

                dispatch(indexConflicts());
                dispatch(indexTasks());

                // Redirect user to front page
                return dispatch(indexEvent({}));

            })
            .catch(err => {
                dispatch(error(err));
                throw err;
            });
    };
}

/**
 * Export the components
 */

export { clearPeriod as default };
export { request, success, error };
